import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IkpEnvironmentService } from '../environment/ikp-environment.service';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private envService = inject(IkpEnvironmentService);
  protected httpClient = inject(HttpClient);
  protected apiUrl = this.envService.getApiUrl();
  protected staticContentUrl = this.envService.getStaticContentUrl();
}
